import {AppThunk} from '../../index';
import data from './data';
import {sleep} from '../../../../shared/pipes/sleep';
import {StateAssignment} from '../../../../shared/models/socialSupport/stateAssignments';
import {stateAssignmentsSlice} from '../../../reducers/socialSupport/stateAssignments';

export const setStateAssignments = stateAssignmentsSlice.actions.setStateAssignment;

export const getStateAssignments = (): AppThunk => {
  return async (dispatch) => {
    // const response = await httpService.get<StateAssignment[]>(getApiRoute(urls.getStateAssignment));
    await sleep(10);
    const response = data as StateAssignment[]; // ToDo: заменить на вызов api когда будет доступен
    dispatch(setStateAssignments(response));
  };
};
